// Project Imports
import { useTokenContext } from 'contexts/resource/ResourceContext';

const usePermission = (): ((permissionName: string) => boolean) => {
  const { modulePermission } = useTokenContext();
  return (permissionName: string): boolean =>
    modulePermission?.includes(permissionName);
};

export default usePermission;
